import { getMessages } from '../../../../../../../../store/constants';
import { IChatsCheckbox, IChatsRadio } from './types';
import { EChatDashboardSettingsScope } from '../../../../../../../../types/rest/IRestChatDashboardSettings';

export const CHATS_TITLE = getMessages().getText('board_settings.chats.title');
export const CHATS_SCOPE_FOR_ALL_CARDS = getMessages().getText('board_settings.chats.scope.all');
export const CHATS_SCOPE_WHEN = getMessages().getText('board_settings.chats.scope.when');
export const CHATS_SCOPE_CREATE = getMessages().getText('board_settings.chats.scope.create');
export const CHATS_SCOPE_MENTIONED = getMessages().getText('board_settings.chats.scope.mentioned');
export const CHATS_SCOPE_ASSIGNED = getMessages().getText('board_settings.chats.scope.assigned');
export const CHATS_SCOPE_ADD = getMessages().getText('board_settings.chats.scope.add');

export const CHATS_TYPE_RADIO: IChatsRadio[] = [
    {title: CHATS_SCOPE_FOR_ALL_CARDS, value: EChatDashboardSettingsScope.SETTING_ALL},
    {title: CHATS_SCOPE_WHEN, value: EChatDashboardSettingsScope.SETTING_WHEN},
]

export const CHATS_TYPE_CHECKBOXES: IChatsCheckbox[] = [
    {title: CHATS_SCOPE_CREATE, value: EChatDashboardSettingsScope.SETTING_EVENT_I_CREATE_CARD},
    {title: CHATS_SCOPE_MENTIONED, value: EChatDashboardSettingsScope.SETTING_I_AM_MENTIONED_IN_COMMENT},
    {title: CHATS_SCOPE_ASSIGNED, value: EChatDashboardSettingsScope.SETTING_CARD_ASSIGNED_TO_ME},
    {title: CHATS_SCOPE_ADD, value: EChatDashboardSettingsScope.SETTING_I_ADD_COMMENT},
];
